import React from 'react';
import { Route } from 'react-router-dom';
import AuthenticationCheck from '../../../common/components/AuthenticationCheck';
import LoggedInRedirect from './LoggedInRedirect';

export default props => {
  return (
    <AuthenticationCheck>
      {({ success }) => {
        if (!success) {
          return <Route {...props} />;
        }

        // cleaning out props
        // eslint-disable-next-line no-unused-vars, react/prop-types
        const { component, children, render, ...rest } = props;
        return <Route {...rest} component={LoggedInRedirect} />;
      }}
    </AuthenticationCheck>
  );
};



// WEBPACK FOOTER //
// ./src/App/auth/Views/UnauthMatch.js